import React, { useState } from 'react';
import { useAuth } from '../../context';
import { Input, Card } from '../../components/common';
import { Link, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import AppButton from '../../components/common/AppButton';
import { paths } from '../../routing/paths';
import { Button } from '@mui/material';

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await forgotPassword(email);
      setEmailSent(true);
    } catch (err) {
      setError('Failed to send reset password email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 4,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 320, padding: 4 }} elevation={0}>
        <Typography variant="h5" align="center" gutterBottom>
          Forgot Password
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {emailSent ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            A password reset link has been sent to your email address. Please check your inbox.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <AppButton type="submit" isFullWidth isLoading={loading} style={{ marginTop: 16 }}>
              Send Reset Link
            </AppButton>
          </form>
        )}
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Button
            component={Link}
            to={paths.login}
            variant="text"
            sx={{ textTransform: 'none', width: '100%' }}
          >
            Back to Login
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default ForgotPassword;
